<template>
  <v-btn
    :disabled="disabled"
    @click="$emit('click')"
    small
    color="white"
    class="ma-0 mr-3"
  >
    <v-icon size="14" left>{{ icon }}</v-icon>
    <span style="text-transform: none; font-size: 12px">{{ label }}</span>
  </v-btn>
</template>

<script>
export default {
  name: "ViewPageButton",
  props: {
    icon: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Management/ViewPage/ViewPageButton.vue